import ResourceList from "../resources/ResourceList";
import { resourcesConfig } from "../resources/resourcesConfig";

const Pacientes = () => {
    return <ResourceList {...resourcesConfig.pacientes} />;
};

export default Pacientes;